import { EconomicActivityEntity } from '../entities/economic-activity-entity';

export default class State {
  items: Array<EconomicActivityEntity> = [];
}
